import apiClient from './apiClient';

export const calculatePositionSize = async ({ accountBalance, riskPercent, entry, stopLoss, currency }) => {
  const { data } = await apiClient.post('/tools/position-size', {
    accountBalance,
    riskPercent,
    entry,
    stopLoss,
    currency,
  });
  return data;
};

export default {
  calculatePositionSize,
};


